import React from 'react';
export const StickyAlertBar = () => {
  return <div className="sticky top-0 z-50 bg-accent-rose text-text-dark py-2 px-4 text-center text-sm md:text-base font-medium shadow-sm" data-id="element-167">
      <span className="animate-pulse inline-block mr-2" data-id="element-168">✨</span>
      Oferta especial: <strong data-id="element-169">70% de descuento</strong> solo por hoy. Cupos
      limitados.
    </div>;
};